import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import TextField from '@mui/material/TextField';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import BillPrint from './Bill';
import ReactDOM from 'react-dom';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';
import { Info } from '@mui/icons-material';


function ReceiptIndex() {
    const history = useHistory();

    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const [remark, setRemark] = useState('');

    const { isAuthenticated, companyId, userId, permissions, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        fetchTableData();
    }, [isAuthenticated, companyId, token, logout]);


    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    useEffect(() => {

        fetchtableData();

    }, []);

    const fetchTableData = async () => {

        setLoading(true); // Set loading state to true when fetching starts
        try {

            const response = await fetchData('ReceiptApi', `/CustomerDetails/${companyId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);

            }
        } catch (error) {
            console.error('Error fetching Packing Slip Details:', error);
        }

    };
    const fetchtableData = async () => {

        fetchData('ReceiptApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Receipt Details:', error);
            });


    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const handleDelete = async () => {
        if (!remark.trim()) {
            alert("Please enter a remark before deleting.");
            return;
        }

        const requestData = {
            id: deleteItemId,
            deletedRemarks: remark, // Pass the remark to API
        };

        updateData('ReceiptApi', `${deleteItemId}`, requestData, token) // Ensure API handles JSON payload
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset item ID
                setConfirmDialogOpen(false); // Close the dialog
                setRemark(''); // Reset remark input
            })
            .catch((error) => {
                console.error("Error deleting record:", error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ReceiptApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
            })
            .catch((error) => {
                // Handle errors for the activation request
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handlePrint = async (rid) => {
        try {
            // Fetch data
            const response = await fetchData('ReceiptApi', `/ReceiptPrint/${rid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];
            console.log(response);
            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();

        } catch (error) {
            console.error('Error printing Estimate:', error);
        }

    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">


            <div className='w-full mb-2 flex flex-wrap items-center'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    Receipt List
                </h6>

                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '20px'
                        }}
                    />
                </div>
                <div className='flex flex-col md:flex-row items-center mb-2 md:mb-0'>
                    <div className='flex flex-col md:mr-2 max-w-full md:max-w-xs'>
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1" htmlFor="fromDate">
                            From Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                        />
                    </div>
                    <div className='flex flex-col md:ml-2 max-w-full md:max-w-xs'>
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1" htmlFor="toDate">
                            To Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                        />
                    </div>
                </div>
                <Button
                    style={{
                        marginTop: '20px',
                        background: 'linear-gradient(to right, darkslategray, slategray)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    {/* <IconButton onClick={fetchTableData}>
                        <RefreshIcon style={{ color: 'white' }} />
                    </IconButton> */}
                    <span style={{ color: 'white', fontWeight: 'bolder', marginLeft: '5px' }}>Refresh</span>
                </Button>
                {hasCreateTransactionPermission && (
                    <Button
                        component={Link}
                        to="/ReceiptCreate"
                        style={{
                            marginTop: '20px',
                            background: 'linear-gradient(to right, darkslategray, slategray)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        className="linkcolor"
                    >

                        <span style={{ color: 'white', fontWeight: 'bolder', marginLeft: '5px' }}>Create</span>
                    </Button>
                )}
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#0B5345' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Ref Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Ref No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Party</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Remark</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', textAlign: 'right', padding: '5px' }}>Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', textAlign: 'center', padding: '5px' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: 'white' }}>
                            {filteredData.map(item => (
                                <TableRow key={item.Id} className={item.IsActive ? 'activeRow' : 'inactiveRow'}>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{formatDate(item.ReferenceDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.ReferenceNo}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{/*{item.PartyName}{item.AddressLine1}{item.CustomerCode} */}
                                        {`${item.PartyName} ${item.AddressLine1} ${item.CustomerCode}`}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black' }}>{item.Remarks}</TableCell>
                                    <TableCell sx={{ bborderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', textAlign: 'right' }}>{item.Amount.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', textAlign: 'center' }}>

                                        {/* <Link to={`/ReceiptEdit/${item.Id}`}>
                                            <IconButton>
                                                <EditIcon style={{ color: 'blueviolet' }} />
                                            </IconButton>
                                        </Link> */}

                                        <Tooltip title=" Print ">
                                            <IconButton onClick={() => handlePrint(item.Id)}>
                                                <PrintIcon style={{ color: 'darkcyan' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Link to={`/ReceiptDetails/${item.Id}`}>
                                            <IconButton>
                                                <Info style={{ color: 'darkblue' }} />
                                            </IconButton>
                                        </Link>
                                        {hasDeleteTransactionPermission && (
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                {item.IsActive ? <DeleteIcon style={{ color: 'brown' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        {/* Delete confirmation dialog */}
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record? Please enter a remark before confirming.
                                </DialogContentText>
                                <TextField
                                    label="Enter Remark"
                                    fullWidth
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                    variant="outlined"
                                    multiline
                                    rows={2}
                                    style={{ marginTop: '10px' }}
                                />
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default ReceiptIndex;

